import { Modal, useModalState } from '@brenger/react';
import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import van1x from '../../../../assets/images/full-service-van@1x.png';
import van2x from '../../../../assets/images/full-service-van@2x.png';
import { IconInfo } from '../../../../brenger-shared-ui';
import { MAX_WEIGHT } from '../../../../utils/global';
import { translate } from '../../../../utils/localization';

export const ServiceLimitsHint = (): JSX.Element => {
  const modal = useModalState();

  return (
    <>
      <div className="text-gray-500 text-sm flex items-center">
        <Translate
          id={'request_flow.product_selection.max_transport_weight'}
          data={{
            weightInKg: MAX_WEIGHT,
          }}
        />
        <button type="button" className="btn-no-style ml-1 cursor-pointer" onClick={modal.open} aria-label="Afmetingen">
          <IconInfo color="blue" style={{ fontSize: '0.75rem' }} />
        </button>
      </div>

      <Modal isOpen={modal.isOpen} close={modal.close} header={<h5>Afmetingen</h5>}>
        <img
          src={van1x}
          srcSet={`${van1x} 1x, ${van2x} 2x`}
          width={348}
          height={150}
          alt=""
          className="block mx-auto mb-4"
        />

        <div
          dangerouslySetInnerHTML={{
            // eslint-disable-next-line @typescript-eslint/naming-convention
            __html: translate('request_flow.items.explain.modal_body_volume'),
          }}
        />
      </Modal>
    </>
  );
};
